import { PREORDER_COOKIE_NAME, QUIZ_COMPLETE_COOKIE_NAME, QUIZ_EMAIL_NAME } from '@/lib/checkoutConstants'
import { trackLandingViewEvent } from '@/lib/gtm/gtmV2'
import { useCheckoutCountry } from '@/lib/hooks/useCheckoutCountry'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { QuizLandingPageContent } from '@/components/pages/quiz/QuizLandingPageContent'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

export const QuizLandingPage: React.FC = () => {
  const router = useRouter()
  const [cookies] = useCookies([QUIZ_COMPLETE_COOKIE_NAME, PREORDER_COOKIE_NAME, QUIZ_EMAIL_NAME])
  const { isReady, checkoutCountry, allowedCheckoutCountries } = useCheckoutCountry()
  const [displayQuizPage, setDisplayQuizPage] = useState(false)
  const [title] = useState<string>('ZOE: Personalised nutrition')

  useEffect(() => {
    if (!isReady || !router.isReady) {
      return
    }

    const inAllowedCountries = checkoutCountry && allowedCheckoutCountries.includes(checkoutCountry)

    if (!inAllowedCountries) {
      router.push({ pathname: '/signup', query: router.query })
      return
    }

    if (cookies[QUIZ_COMPLETE_COOKIE_NAME] || cookies[QUIZ_EMAIL_NAME]) {
      const queryParams = { ...router.query, ...{ country: checkoutCountry, quizCompleteRedirect: true } }
      router.replace({ pathname: '/buymembership', query: queryParams })
      return
    }

    setDisplayQuizPage(true)
  }, [allowedCheckoutCountries, checkoutCountry, isReady, router, cookies])

  useEffect(() => {
    if (displayQuizPage) {
      trackLandingViewEvent('quiz', title, 'v1')
    }
  }, [displayQuizPage, title])

  const metaData = {
    title,
    description: `Find out what's possible with ZOE's scientific analysis of your body's responses to food`,
    twitterCard: `Find out what's possible with ZOE's scientific analysis of your body's responses to food`,
    image: {
      url: 'https://www.datocms-assets.com/46938/1636987920-577b99f94bf109457336d3964f77709e.jpeg?auto=format&crop=focalpoint&fit=crop&h=627&q=75&w=1200',
      responsiveImage: {
        url: 'https://www.datocms-assets.com/46938/1636987920-577b99f94bf109457336d3964f77709e.jpeg?auto=format&crop=focalpoint&fit=crop&h=627&q=75&w=1200',
      },
    },
    noIndex: false,
  }
  return (
    <>
      <SEOMetaTags metaData={metaData} path={router.asPath} />
      {displayQuizPage ? <QuizLandingPageContent checkoutCountry={checkoutCountry} /> : null}
    </>
  )
}
